
define('jst!tooltips/_question',['underscore','translate'],function () { var _ = require('underscore');
var t = require('translate');
return _.template('<% _.map(data.userImages, function(i) {\n  print(content_tag(\'img\', { src : i }));\n})%>');
 });

